module.exports = __webpack_public_path__ + "static/media/cams_folio.fe41ed82.png";